// extracted by mini-css-extract-plugin
export var container = "recipe-search-item-module--container--12885";
export var img = "recipe-search-item-module--img--213ca";
export var label = "recipe-search-item-module--label--3000c";
export var labels = "recipe-search-item-module--labels--81cb2";
export var link = "recipe-search-item-module--link--c0dfc";
export var lock = "recipe-search-item-module--lock--eee1b";
export var name = "recipe-search-item-module--name--51211";
export var nameBox = "recipe-search-item-module--name-box--f5519";
export var selected = "recipe-search-item-module--selected--d7586";
export var suggestedIcon = "recipe-search-item-module--suggested-icon--7beda";
export var suggestedLabel = "recipe-search-item-module--suggested-label--d2dd9";